const getBaseStyles = () => ({
  container: {
    position: 'relative',
    width: '400px',
    maxWidth: '90%',
    height: '320px',
    perspective: '1000px',
    userSelect: 'none',
    touchAction: 'none',
    boxSizing: 'border-box',
    margin: '0 auto',
    transform: 'translateX(-5px)',
  },
  controls: {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '20px',
    color: 'var(--app-text-muted)',
    fontSize: '14px',
    zIndex: 10,
    backgroundColor: 'var(--app-surface-elevated)',
    padding: '8px 16px',
    borderRadius: '20px',
    boxShadow: 'var(--app-shadow)',
    border: '1px solid var(--app-border)',
  },
  arrowKey: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px',
    borderRadius: '4px',
    fontWeight: 500,
  },
  arrow: {
    fontSize: '20px',
    color: 'var(--app-text)',
  },
  '@media (max-width: 600px)': {
    container: {
      height: '250px',
      width: '100%',
    },
  }
});

export const getCardStyles = (startX, offset, isVisible) => ({
  ...getBaseStyles(),
  card: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: '20px',
    boxSizing: 'border-box',
    cursor: 'grab',
    transition: startX === null ? 'all 0.5s ease-in-out' : 'none',
    transform: isVisible ? `translateX(${offset}px) rotate(${offset * 0.05}deg)` : 'translateX(-100vw) rotate(0deg)',
    opacity: isVisible ? 1 : 0,
    pointerEvents: isVisible ? 'auto' : 'none',
    backfaceVisibility: 'hidden',
    willChange: 'transform, opacity',
    display: isVisible ? 'block' : 'none',
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'var(--app-surface-elevated)',
    borderRadius: '20px',
    boxShadow: 'var(--app-shadow)',
    border: '1px solid var(--app-border)',
    overflow: 'hidden',
  },
  word: {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontWeight: 'bold',
    color: 'var(--app-text)',
    textAlign: 'center',
    width: '90%',
    padding: '20px',
    letterSpacing: '0.02em',
    lineHeight: '1.4',
  },
  split: {
    position: 'absolute',
    bottom: 0,
    width: '50%',
    height: '44%',
    display: 'flex',
    alignItems: 'flex-end',
    padding: '16px',
    transition: 'opacity 0.3s',
  },
  leftSplit: {
    left: 0,
    background: 'linear-gradient(to right, var(--app-negative-glow), transparent)',
    justifyContent: 'flex-start',
    opacity: offset < 0 ? 1 : 0.5,
  },
  rightSplit: {
    right: 0,
    background: 'linear-gradient(to left, var(--app-accent-soft), transparent)',
    justifyContent: 'flex-end',
    opacity: offset > 0 ? 1 : 0.5,
  },
  meaning: {
    color: 'var(--app-text)',
    maxWidth: '90%',
    textAlign: 'center',
    letterSpacing: '0.01em',
    lineHeight: '1.4',
    fontSize: '1.2em',
    fontWeight: '500',
  }
});
